import Reveal from "../Reveal";
import { ArrowRight } from "lucide-react";

const services = [
  {
    id: "audit",
    label: "Service 01",
    title: "Communications Audit",
    description:
      "A fresh pair of eyes on your communications. We'll review your website, messaging, content, customer journey and engagement activity to identify what's working, what's missing and where opportunities exist.",
    outcome: "A practical roadmap for stronger communication and growth.",
    cta: "Book a Communications Audit",
  },
  {
    id: "partner",
    label: "Service 02",
    title: "Communications Partner",
    description:
      "Senior communications support without employing a full-time communications manager. Ongoing strategic and practical support to help you communicate clearly, engage effectively and grow with confidence.",
    outcome:
      "Consistent communications that strengthen your reputation and support your ambitions.",
    cta: "Let's Talk About Growth",
  },
];

export default function Services({ onContactOpen }) {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-36 border-t border-[#E2DCD0]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <Reveal className="max-w-3xl mb-16 md:mb-24">
          <p className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[#C86A53] mb-8">
            04 — How We Work
          </p>
          <h2 className="font-display font-light tracking-tighter leading-[0.95] text-[#0F172A] text-5xl md:text-6xl lg:text-7xl">
            Services, <span className="italic">crafted</span> around your ambitions.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 border-t border-[#E2DCD0]">
          {services.map((s, i) => (
            <Reveal
              key={s.id}
              delay={i * 0.1}
              className={`p-8 md:p-12 lg:p-16 ${
                i === 0
                  ? "lg:border-r border-[#E2DCD0] border-b lg:border-b-0"
                  : ""
              }`}
            >
              <div data-testid={`service-${s.id}`} className="h-full flex flex-col">
                <p className="text-[11px] uppercase tracking-[0.3em] text-[#C86A53] mb-6">
                  {s.label}
                </p>

                <h3 className="font-display text-4xl md:text-5xl font-light leading-tight tracking-tight text-[#0F172A] mb-6">
                  {s.title}
                </h3>

                <p className="text-base md:text-lg leading-relaxed text-[#475569] font-light mb-8">
                  {s.description}
                </p>

                <div className="border-t border-[#E2DCD0] pt-6 mb-8">
                  <p className="text-[11px] uppercase tracking-[0.3em] text-[#0F172A] font-semibold mb-2">
                    Outcome
                  </p>
                  <p className="font-display italic text-xl md:text-2xl text-[#0F172A] leading-snug">
                    {s.outcome}
                  </p>
                </div>

                <div className="mt-auto">
                  <button
                    data-testid={`service-cta-${s.id}`}
                    onClick={() => onContactOpen(s.id)}
                    className="group inline-flex items-center gap-3 bg-[#0F172A] hover:bg-[#C86A53] text-[#F9F6F0] px-6 py-4 text-xs uppercase tracking-[0.22em] font-semibold transition-all duration-300"
                  >
                    {s.cta}
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
